// removed by extract-text-webpack-plugin
module.exports = {"container":"_2mW0vnV","container__hidden":"_3Jzwqs8","body":"_2kDR6LR","navigation":"_2gP-s5Y"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiscBar/MiscBar.css
// module id = ./template/components/MiscBar/MiscBar.css
// module chunks = client.sitechrome